
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.876 14.295l-.766 2.859-2.8.059A10.95 10.95 0 011 12c0-1.824.444-3.544 1.23-5.059l2.492.457 1.092 2.477A6.538 6.538 0 005.46 12c0 .807.146 1.581.415 2.295z","fill":"#FBBB00"}}),_c('path',{attrs:{"d":"M22.808 9.945c.126.665.192 1.353.192 2.055a10.997 10.997 0 01-4.113 8.578h-.001l-3.139-.16-.444-2.774a6.555 6.555 0 002.82-3.347h-5.881V9.945H22.808z","fill":"#518EF8"}}),_c('path',{attrs:{"d":"M18.886 20.577v.001A10.954 10.954 0 0112 23c-4.189 0-7.831-2.342-9.689-5.787l3.565-2.918a6.54 6.54 0 009.427 3.35l3.583 2.932z","fill":"#28B446"}}),_c('path',{attrs:{"d":"M19.021 3.532L15.458 6.45a6.542 6.542 0 00-9.644 3.425L2.231 6.94H2.23A10.998 10.998 0 0112 1c2.669 0 5.116.95 7.021 2.532z","fill":"#F14336"}})])
          )
        }
      }
    